(function () {
  angular
    .module("akitabox.workOrder.buildingList")
    .controller(
      "WorkOrderBuildingListController",
      WorkOrderBuildingListController
    );

  /**
   * @ngdoc controller
   * @module akitabox.workOrder.buildingList
   * @description
   *
   */
  /* @ngInject */
  function WorkOrderBuildingListController(
    // Angular
    $location,
    $scope,
    // Third party
    $state,
    // Constants
    WORK_ORDER_STATUS_SCHEDULED_OPEN,
    WORK_ORDER_STATUS_CLOSED,
    // Services
    models,
    WorkOrderService,
    FeatureFlagService,
    // Resolve
    building,
    query,
    status
  ) {
    var self = this;

    var filter = WorkOrderService.getBuildingListFilter(building._id) || {};

    // General query parameters
    var baseQuery = {
      open: {
        status: WORK_ORDER_STATUS_SCHEDULED_OPEN,
      },
      closed: {
        status: WORK_ORDER_STATUS_CLOSED,
      },
    };

    // Models
    self.building = building;

    // Attributes
    self.activeTab = status === "closed" ? 1 : 0;
    self.workOrders = {};
    self.searchText = null;

    // Functions
    self.getStatusClass = getStatusClass;
    self.onSelectTab = onSelectTab;
    self.selectWorkOrder = selectWorkOrder;
    self.hasLoadedOpen = hasLoadedOpen;
    self.hasLoadedClosed = hasLoadedClosed;
    self.emptyOpenList = emptyOpenList;
    self.emptyClosedList = emptyClosedList;
    self.addWorkOrder = addWorkOrder;
    self.addServiceRequest = addServiceRequest;

    init();

    /**
     * Initialize controller, request work orders
     */
    function init() {
      // Initialize search. Default to querystring, then cached filter
      self.searchText = query ? query : filter.q;
      fetchWorkOrders(self.searchText);
      self.searchOpen = !angular.isEmpty(self.searchText);
      // Watch search text
      $scope.$watch("vm.searchText", angular.debounce(onSearchChangeText, 500));
    }

    function onSearchChangeText(newValue, oldValue) {
      if (newValue !== oldValue) fetchWorkOrders(newValue);
    }

    function updateFilter(params) {
      filter = angular.extend(filter, params);
      WorkOrderService.setBuildingListFilter(building._id, filter);
    }

    function fetchWorkOrders(text) {
      $location.search("q", text);
      updateFilter({ q: text });
      var openParams = angular.extend({}, baseQuery.open, filter);
      var closedParams = angular.extend({}, baseQuery.closed, filter);
      var queryParams =
        "_number=" +
        filter.q +
        ";subject=" +
        filter.q +
        ";description_text=" +
        filter.q;

      if (filter.q) {
        openParams.$or = queryParams;
        closedParams.$or = queryParams;
        delete openParams.q;
        delete closedParams.q;
      }

      openParams.building = building._id;
      closedParams.building = building._id;

      self.workOrders.open = WorkOrderService.getVirtualRepeat(
        building.organization,
        10,
        openParams
      );
      self.workOrders.closed = WorkOrderService.getVirtualRepeat(
        building.organization,
        10,
        closedParams
      );
    }

    function addServiceRequest() {
      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;

      $state.go("app.serviceRequests.create", params);
    }

    function addWorkOrder() {
      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;

      $state.go("app.workOrders.create", params);
    }

    /**
     * Retrieve class for work order status (warn, success, etc.)
     *
     * @param  {Object} workOrder   Work order
     * @return {String}             Class name
     */
    function getStatusClass(workOrder) {
      var status = workOrder ? workOrder.status_display : null;

      switch (status) {
        case "Overdue":
          return "fg-warn";
        case "Open":
          return "fg-success";
        case "Completed":
          return "fg-dark";
        default:
          return "fg-black";
      }
    }

    /**
     * Handle tab selection, update URL status query
     *
     * @param {String} tab Tab name (open, closed)
     */
    function onSelectTab(tab) {
      $location.search("status", tab);
    }

    /**
     * Navigate to work order details
     *
     * @param {Object} workOrder    The selected work order
     */
    function selectWorkOrder(workOrder) {
      $state.go("app.building.workOrder.detail", {
        buildingId: building._id,
        workOrderId: workOrder._id,
      });
    }

    function hasLoadedOpen() {
      return angular.isNumber(self.workOrders.open.numItems);
    }

    function hasLoadedClosed() {
      return angular.isNumber(self.workOrders.closed.numItems);
    }

    function emptyOpenList() {
      return (
        self.workOrders.open.getLength() === 0 &&
        !self.workOrders.open.moreToLoad &&
        !self.workOrders.open.fetching
      );
    }

    function emptyClosedList() {
      return (
        self.workOrders.closed.getLength() === 0 &&
        !self.workOrders.closed.moreToLoad &&
        !self.workOrders.closed.fetching
      );
    }
  }
})();
